import React from "react";
import LegalLayout from "../../component/Legal/LegalLayout";

const sections = [
  {
    heading: "Who We Are and Acceptance of These Terms",
    body: (
      <>
        <p>
          This website, devdesk.ng (the "Site"), is owned and operated by DevDesk Integrated
          Services ("DevDesk", "we", "us" or "our"), a software company registered in the
          Federal Republic of Nigeria. We build and license enterprise software, including
          the Devdesk Pool platform and the forthcoming Auditra accounting solution.
        </p>
        <p>
          By accessing or using the Site, you agree to be bound by these Terms of Use
          (the "Terms"). If you do not agree to these Terms, you must not use the Site.
          If you are using the Site on behalf of a company or other legal entity, you
          represent that you have authority to bind that entity, and "you" refers to
          that entity.
        </p>
      </>
    ),
  },
  {
    heading: "Nature of Our Services",
    body: (
      <>
        <p>
          DevDesk is a business-to-business technology provider. Through the Site we
          describe, market and offer our software products and professional services,
          including white-label pool betting software (Devdesk Pool), accounting
          software (Auditra), and custom software development.
        </p>
        <p>
          The Site is an informational and marketing channel. Use of any DevDesk
          software product by a client is governed by a separate written agreement
          (such as a licence, subscription or services agreement) between DevDesk and
          that client. In the event of any conflict between these Terms and a signed
          agreement, the signed agreement prevails for the subject matter it covers.
        </p>
      </>
    ),
  },
  {
    heading: "DevDesk Is Not a Betting or Gaming Operator",
    body: (
      <>
        <p>
          Devdesk Pool is licensed to independent betting operators ("Operators") who
          run their own businesses on it. Each Operator platform referenced or linked
          on this Site, including D.Buxton United Pools, De-Minister Pools, Lawray
          Pools Fixed Odds, Eagle United Pools, Praise Pools and De-Best Global Fixed
          Odds, is owned and operated solely by the relevant Operator, under that
          Operator's own name, branding, licences and regulatory approvals.
        </p>
        <p>
          DevDesk does not accept stakes, hold player funds, set odds, determine
          outcomes or pay winnings, and is not a party to any wager. Any betting
          activity you engage in on an Operator's platform is governed exclusively by
          that Operator's own terms and conditions, and any dispute arising from such
          activity (including stakes, winnings, account or payment matters) must be
          directed to the relevant Operator. DevDesk accepts no liability for the
          acts, omissions, solvency or regulatory compliance of any Operator.
        </p>
        <p>
          Betting is restricted to persons of legal gambling age in their
          jurisdiction. Nothing on this Site constitutes an invitation to gamble.
        </p>
      </>
    ),
  },
  {
    heading: "Eligibility and Acceptable Use",
    body: (
      <>
        <p>You agree that you will not, and will not attempt to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>use the Site for any unlawful purpose or in breach of any applicable law or regulation;</li>
          <li>probe, scan, or test the vulnerability of the Site or any related system, or breach any security or authentication measure;</li>
          <li>copy, scrape, harvest or index the Site or its content by automated means without our prior written consent;</li>
          <li>interfere with the proper working of the Site, including by transmitting malware or imposing an unreasonable load on our infrastructure;</li>
          <li>impersonate DevDesk, an Operator, or any other person, or misrepresent your affiliation with any person or entity; or</li>
          <li>use the Site to send unsolicited commercial communications.</li>
        </ul>
        <p>
          We may suspend or restrict access to the Site at any time, without notice,
          where we reasonably believe these Terms have been breached.
        </p>
      </>
    ),
  },
  {
    heading: "Intellectual Property",
    body: (
      <>
        <p>
          The Site and all content on it, including text, graphics, page designs,
          logos, product names (including "DevDesk", "Devdesk Pool" and "Auditra"),
          software, source code and documentation, are the property of DevDesk or
          its licensors and are protected by copyright, trade mark and other
          intellectual property laws of Nigeria and other jurisdictions.
        </p>
        <p>
          Operator names and logos displayed on the Site are the trade marks of their
          respective owners and are displayed with permission, solely to identify
          clients of DevDesk. Nothing on the Site grants you any licence or right to
          use any trade mark, logo or other proprietary material without the prior
          written consent of its owner.
        </p>
        <p>
          You may view, download and print pages from the Site for your own lawful
          business evaluation purposes, provided you keep all proprietary notices
          intact and do not modify the materials.
        </p>
      </>
    ),
  },
  {
    heading: "Demo Requests, Enquiries and Communications",
    body: (
      <>
        <p>
          Where you submit a contact form, request a demonstration, join a waitlist
          or apply for a role, you warrant that the information you provide is
          accurate and that you are authorised to provide it. Submitting an enquiry
          does not create any contractual relationship; any engagement is subject to
          a separate written agreement.
        </p>
        <p>
          Our handling of personal data submitted through the Site is described in
          our Privacy Policy.
        </p>
      </>
    ),
  },
  {
    heading: "Third-Party Links",
    body: (
      <p>
        The Site contains links to third-party websites, including Operator
        platforms. These are provided for convenience only. We do not control and
        are not responsible for the content, policies or practices of any
        third-party website, and a link does not imply endorsement. You access
        third-party websites at your own risk and subject to their terms.
      </p>
    ),
  },
  {
    heading: "Disclaimers",
    body: (
      <>
        <p>
          The Site and its content are provided on an "as is" and "as available"
          basis. To the fullest extent permitted by law, DevDesk excludes all
          warranties, conditions and representations of any kind, whether express or
          implied, including as to accuracy, completeness, merchantability, fitness
          for a particular purpose and non-infringement.
        </p>
        <p>
          Content on the Site, including product descriptions, statistics and
          illustrative dashboards, is for general information and marketing
          purposes only and does not constitute professional, financial, legal or
          gambling advice, nor a binding offer capable of acceptance.
        </p>
      </>
    ),
  },
  {
    heading: "Limitation of Liability",
    body: (
      <>
        <p>
          To the fullest extent permitted by applicable law, DevDesk, its directors,
          employees and agents shall not be liable for any indirect, incidental,
          special, consequential or punitive damages, or for any loss of profits,
          revenue, data, goodwill or business opportunity, arising out of or in
          connection with your use of (or inability to use) the Site, even if
          advised of the possibility of such damages.
        </p>
        <p>
          To the extent any liability cannot be excluded, DevDesk's total aggregate
          liability arising out of or in connection with the Site shall not exceed
          one hundred thousand Naira (₦100,000). Nothing in these Terms excludes or
          limits liability for fraud, or any other liability that cannot be excluded
          by Nigerian law.
        </p>
      </>
    ),
  },
  {
    heading: "Indemnity",
    body: (
      <p>
        You agree to indemnify and hold harmless DevDesk, its directors, employees
        and agents from and against all claims, liabilities, damages, losses and
        expenses (including reasonable legal fees) arising out of or related to
        your breach of these Terms or your misuse of the Site.
      </p>
    ),
  },
  {
    heading: "Changes to These Terms",
    body: (
      <p>
        We may revise these Terms at any time by posting an updated version on this
        page with a revised "Last updated" date. Your continued use of the Site
        after changes are posted constitutes acceptance of the revised Terms. We
        encourage you to review this page periodically.
      </p>
    ),
  },
  {
    heading: "Governing Law and Disputes",
    body: (
      <p>
        These Terms are governed by and construed in accordance with the laws of
        the Federal Republic of Nigeria. The parties shall first attempt in good
        faith to resolve any dispute arising out of or in connection with these
        Terms amicably; failing resolution within thirty (30) days, the dispute
        shall be subject to the exclusive jurisdiction of the courts of Nigeria.
      </p>
    ),
  },
  {
    heading: "Contact",
    body: (
      <p>
        Questions about these Terms should be directed to DevDesk Integrated
        Services at{" "}
        <a href="mailto:devdesk.services@gmail.com" className="text-[#0186ef] hover:underline">
          devdesk.services@gmail.com
        </a>
        , or through the contact form on this Site.
      </p>
    ),
  },
];

const TermsPage = () => (
  <LegalLayout
    title="Terms of Use"
    subtitle="The terms that govern your use of the DevDesk website and the relationship between DevDesk, its clients and their customers."
    lastUpdated="3 October 2026"
    sections={sections}
  />
);

export default TermsPage;
